export const SelectionTreeSchema = {
  type: 'object',
  additionalProperties: true,
  properties: {
    controlType: { const: 'selection-tree' },
    leftTree: { type: 'object'},
    rightTree: { type: 'object'},
  }
};
